import { useGetInspectorQuery } from 'app/api_v2/agency/queries';
import TickedAddDirect from 'app/main/common/tickets/ticket-details/components/ticket-add-direct/TicketAddDirect';
import { getUserRoleInfo } from 'app/ui_v2/helpers/users';
import { useParams } from 'react-router-dom';

import { Box, Typography } from '@mui/material';

import ProfileInfo from '../../profile-info/ProfileInfo';
import InspectorStatusBadge from './InspectorStatusBadge';

export default function LayoutHeader() {
  const { id = '' } = useParams();

  const { isSuccess, data } = useGetInspectorQuery(id || '');
  const { isAdmin } = getUserRoleInfo();

  const inspectorName = data?.user?.fullName || `${data?.user?.firstName || ''} ${data?.user?.lastName || ''}`;

  return (
    <Box pt={4} pb={2}>
      <>
        <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap={'wrap'}>
          <Box display="flex" alignItems="flex-start">
            <Typography component="h2" variant="h1" sx={{ mb: 0 }} className="with-indicator">
              {inspectorName}
            </Typography>

            {isSuccess && data && (
              <Box mt={1} mx={3}>
                <InspectorStatusBadge state={data.state} />
              </Box>
            )}
          </Box>
          {isAdmin && data && (
            <Box mb={4} display="flex" alignItems="flex-start">
              <TickedAddDirect
                companyId=""
                companyName=""
                inspectorProfileId={id}
                inspectorName={inspectorName}
                inspectorId={data.userId}
              />
            </Box>
          )}
        </Box>

        {isSuccess && data && <ProfileInfo profileData={data} />}
      </>
    </Box>
  );
}
